import React from "react";
import styled from "styled-components";
import { Container, Row } from "react-bootstrap";
import RocketRoute from "../../assets/rocketroute_logo.png";
import CAMP from "../../assets/camp-logo2x.png";
import AMOS from "../../assets/amos_logo.png";
import Avianis from "../../assets/Avianis.svg";
import Leon from "../../assets/Leon.svg";
import Centrik from "../../assets/centrik_logo.png";
import { AnimationOnScroll } from "react-animation-on-scroll";
import * as styles from "./seamlessIntegration.module.less";

const TitleSpan = styled.h4`
  display: flex;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 0.04px;
  justify-content: center;
  color: #242d41;
  padding-top: 140px;
  padding-bottom: 20px;
  line-height: 1.57;
  margin: 0;
  @media screen and (max-width: 1200px) {
    font-size: 26px;
    padding-top: 40px;
  }
  @media screen and (max-width: 991px) {
    font-size: 22px;
    padding-top: 30px;
  }
  @media screen and (max-width: 768px) {
    text-align: center;
    justify-content: center;
    width: 100%;
  }
  @media screen and (max-width: 576px) {
    padding-top: 0px;
  }
  @media screen and (max-width: 451px) {
    padding: 0;
  }
`;

const StyledGrid = styled.div`
  display: grid;
  // 170px is for Rocket Route as its a silly image
  grid-template-columns: ${({ columns }) =>
    columns ? `${columns}` : "1fr 1fr 1fr 1fr 1fr 170px"};
  justify-content: center;
  align-items: center;
  gap: ${({ gap }) => (gap ? `${gap}` : "2rem")};
  margin: ${({ margin }) => (margin ? `${margin}` : "0")};
  @media screen and (max-width: 786px) {
    grid-template-columns: ${({ columns }) =>
      columns ? `${columns}` : "1fr 1fr 1fr"};
    margin: 0 20%;
  }
  @media screen and (max-width: 451px) {
    grid-template-columns: ${({ columns }) => (columns ? "1fr" : "1fr 1fr")};
    margin: 0;
  }
`;

const TextSpan = styled.div`
  font-size: 16px;
  letter-spacing: 0.02px;
  text-align: center;
  color: #242d41;
  line-height: 1.63;
  margin: 0 10%;
  @media screen and (max-width: 991px) {
    font-size: 14px;
    margin: 0;
  }
  @media screen and (max-width: 767px) {
    text-align: center;
    width: 100%;
    display: block;
    margin: 0;
    margin-bottom: 30px;
  }
`;

const StyledImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const StyledImg = styled.img`
  width: ${({ width }) => (width ? `${width}` : "100%")};
  height: auto;
  @media screen and (max-width: 767px) {
    margin: 10px 0;
  }
  @media screen and (max-width: 451px) {
    width: ${({ width }) => (width ? "50%" : "100%")};
  }
`;

const LeonText = styled.div`
  font-size: 16px;
  @media screen and (max-width: 451px) {
    text-align: center;
  }
`;

const SeamlessIntegration = (props) => {
  return (
    <Container>
      <Row className={styles.seamlessRow}>
        <AnimationOnScroll
          animateOnce
          animateIn="animate__fadeInRight"
          offset={0}
        >
          <TitleSpan dangerouslySetInnerHTML={{ __html: props.title }} />
          {props?.text ? <TextSpan>{props.text}</TextSpan> : null}
        </AnimationOnScroll>
      </Row>
      {props.leonOnly ? (
        <StyledGrid columns="1fr 2fr" margin="0 23%" gap="1rem">
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg width="90%" src={Leon} alt="leon" />
            </StyledImageWrapper>
          </AnimationOnScroll>
          <LeonText>
            For optimal operations, the smart integration between both platforms
            allows to transfer Centrik crew endorsement details directly to
            Leon.
          </LeonText>
        </StyledGrid>
      ) : (
        <StyledGrid>
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg src={AMOS} alt="amos" />
            </StyledImageWrapper>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg src={Avianis} alt="avianis" />
            </StyledImageWrapper>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg src={CAMP} alt="camp" />
            </StyledImageWrapper>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg src={Centrik} alt="centrik" />
            </StyledImageWrapper>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg src={Leon} alt="leon" />
            </StyledImageWrapper>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce
            animateIn="animate__fadeInUp"
            offset={0}
          >
            <StyledImageWrapper>
              <StyledImg src={RocketRoute} alt="rocket" />
            </StyledImageWrapper>
          </AnimationOnScroll>
        </StyledGrid>
      )}
    </Container>
  );
};

export default SeamlessIntegration;
